import { render, staticRenderFns } from "./newAddDialog.vue?vue&type=template&id=d229c2b4&scoped=true&"
import script from "./newAddDialog.vue?vue&type=script&lang=js&"
export * from "./newAddDialog.vue?vue&type=script&lang=js&"
import style0 from "./newAddDialog.vue?vue&type=style&index=0&id=d229c2b4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d229c2b4",
  null
  
)

export default component.exports